module.exports = __webpack_public_path__ + "static/media/encerrada-embarque-sonho.8c1e0c2e.png";